import type { TourSpec } from "./types";

export const classicDealsTour: TourSpec = {
  id: "classicDeals",
  version: 1,
  buildSteps: (t) => [
    {
      target: '[data-tour="classic-deals-controls"]',
      title: t("classicDeals.controls.title"),
      content: t("classicDeals.controls.body"),
      placement: "bottom",
      skipBeacon: true,
    },
    {
      target: '[data-tour="classic-deals-table"]',
      title: t("classicDeals.table.title"),
      content: t("classicDeals.table.body"),
      placement: "center",
      skipBeacon: true,
    },
  ],
};
